import React, { useState, useRef, useEffect } from "react";
import { useMediaQuery } from "react-responsive";

// Import all videos
import musOakisland from "../assets/mus-oakisland.mp4";
import musNineball from "../assets/mus-nineball.mp4";
import musBoysoffaith from "../assets/mus-boysoffaith.mp4";
import musOklahomasmokeshow from "../assets/mus-oklahomasmokeshow.mp4";
import musDriverslicense from "../assets/mus-driverslicense.mp4";
import musCrossthestreet from "../assets/mus-crossthestreet.mp4";
import musColdblood from "../assets/mus-coldblood.mp4";
import musPruneyoutalkfunny from "../assets/mus-pruneyoutalkfunny.mp4";
import musWorldclasscinema from "../assets/mus-worldclasscinema.mp4";
import musPrettylittlefears from "../assets/mus-prettylittlefears.mp4";
import musCold from "../assets/mus-cold.mp4";
import musWillhe from "../assets/mus-willhe.mp4";
import musCrew from "../assets/mus-crew.mp4";
import musDf from "../assets/mus-df.mp4";
import comBm from "../assets/com-bm.mp4";
import comRocket from "../assets/com-rocket.mp4";
import comRoss from "../assets/com-ross.mp4";
import comConverse from "../assets/com-converse.mp4";
import comFacebook from "../assets/com-facebook.mp4";
import comGigi from "../assets/com-gigi.mp4";
import comCiti from "../assets/com-citi.mp4";
import comSky from "../assets/com-sky.mp4";
import comConverse2 from "../assets/com-converse2.mp4";
import comDiamond from "../assets/com-diamond.mp4";
import comNewBalance from "../assets/com-new-balance.mp4";
import comNowness from "../assets/com-nowness.mp4";
import comVogue from "../assets/com-vogue.mp4";
import comAdidas from "../assets/com-adidas.mp4";
import comNike from "../assets/com-nike.mp4";
import comPrada from "../assets/com-prada.mp4";

// Create a lookup object for video sources
const videoSources = {
  "mus-oakisland.mp4": musOakisland,
  "mus-nineball.mp4": musNineball,
  "mus-boysoffaith.mp4": musBoysoffaith,
  "mus-oklahomasmokeshow.mp4": musOklahomasmokeshow,
  "mus-driverslicense.mp4": musDriverslicense,
  "mus-crossthestreet.mp4": musCrossthestreet,
  "mus-coldblood.mp4": musColdblood,
  "mus-pruneyoutalkfunny.mp4": musPruneyoutalkfunny,
  "mus-worldclasscinema.mp4": musWorldclasscinema,
  "mus-prettylittlefears.mp4": musPrettylittlefears,
  "mus-cold.mp4": musCold,
  "mus-willhe.mp4": musWillhe,
  "mus-crew.mp4": musCrew,
  "mus-df.mp4": musDf,
  "com-bm.mp4": comBm,
  "com-rocket.mp4": comRocket,
  "com-ross.mp4": comRoss,
  "com-converse.mp4": comConverse,
  "com-facebook.mp4": comFacebook,
  "com-gigi.mp4": comGigi,
  "com-citi.mp4": comCiti,
  "com-sky.mp4": comSky,
  "com-converse2.mp4": comConverse2,
  "com-diamond.mp4": comDiamond,
  "com-new-balance.mp4": comNewBalance,
  "com-nowness.mp4": comNowness,
  "com-vogue.mp4": comVogue,
  "com-adidas.mp4": comAdidas,
  "com-nike.mp4": comNike,
  "com-prada.mp4": comPrada,
};

function ContentList({ title, content }) {
  const [clickedItem, setClickedItem] = useState(null);
  const [showEmbed, setShowEmbed] = useState(false);
  const musicRef = useRef();
  const commercialRef = useRef();
  const videoRef = useRef();
  const isMobile = useMediaQuery({ query: "(max-device-width: 800px)" });

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!musicRef.current?.contains(e.target) && 
          !commercialRef.current?.contains(e.target) &&
          !videoRef.current?.contains(e.target)) {
        setClickedItem(null);
        setShowEmbed(false);
      }
    };

    const handleKeyDown = (e) => {
      if (!clickedItem) return;
      
      const [category, index] = clickedItem.split('-');
      const currentIndex = parseInt(index);
      const maxIndex = content[category === 'music' ? 0 : 1].length - 1;
      
      if (e.key === 'ArrowDown') {
        if (category === 'music' && currentIndex === maxIndex) {
          setClickedItem('commercial-0');
        } else if (category === 'commercial' && currentIndex === maxIndex) {
          setClickedItem(null);
        } else {
          setClickedItem(`${category}-${currentIndex + 1}`);
        }
      } else if (e.key === 'ArrowUp') {
        if (category === 'music' && currentIndex === 0) {
          setClickedItem(null);
        } else if (category === 'commercial' && currentIndex === 0) {
          setClickedItem(`music-${content[0].length - 1}`);
        } else {
          setClickedItem(`${category}-${currentIndex - 1}`);
        }
      }
      setShowEmbed(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [clickedItem, content]);

  const handleItemClick = (type, index) => {
    setClickedItem(`${type}-${index}`);
    setShowEmbed(false);
  };

  const handleVideoClick = (e) => {
    e.stopPropagation();
    setShowEmbed(!showEmbed);
  };

  const renderList = (items, type, listRef) => (
    <div className="list" ref={listRef}>
      <ul className="artistColumn">
        {items.map((item, index) => (
          <li
            key={index}
            className={clickedItem === `${type}-${index}` ? "selected" : ""}
            onClick={() => handleItemClick(type, index)}
          >
            {item.artist}
          </li>
        ))}
      </ul>
      <ul className="songColumn">
        {items.map((item, index) => (
          <li
            key={index}
            className={clickedItem === `${type}-${index}` ? "selected" : ""}
            onClick={() => handleItemClick(type, index)}
          >
            {item.song}
          </li>
        ))}
      </ul>
    </div>
  );

  const renderVideo = () => {
    if (!clickedItem) return null;
    
    const [category, index] = clickedItem.split('-');
    const item = content[category === 'music' ? 0 : 1][index];
    
    return (
      <div className="highlightedVidWrapper" ref={videoRef}>
        <div className="videoLink" onClick={handleVideoClick}>
          {isMobile || showEmbed ? (
            <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
              <iframe
                title={item.song}
                src={item.href}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              />
            </div>
          ) : (
            <video playsInline muted loop autoPlay key={item.src}>
              <source src={videoSources[item.src]} type="video/mp4" />
            </video>
          )}
          <h3>
            <span>{item.artist}</span> <span>{item.song}</span>
          </h3>
        </div>
      </div>
    );
  };

  return (
    <section className="contentListWrapper">
      <h2>{title[0]}</h2>
      {renderList(content[0], 'music', musicRef)}
      {renderVideo()}
      <h2>{title[1]}</h2>
      {renderList(content[1], 'commercial', commercialRef)}
    </section>
  );
}

export default ContentList;